import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "lp-auto-loan-calculator" }
const _hoisted_3 = { class: "mb-3 mb-lg-4" }
const _hoisted_4 = { class: "mb-3 mb-lg-4" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mb-3 mb-lg-4" }
const _hoisted_7 = { class: "calculator__total" }
const _hoisted_8 = { class: "calculator-total__number" }
const _hoisted_9 = { class: "lp-calculator-disclaimer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_group_input = _resolveComponent("base-group-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.cssClass])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_base_group_input, {
              "required-flag": true,
              inputLabel: "Loan Amount",
              "front-group": "$"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_input, {
                  label: "Loan Amount",
                  modelValue: _ctx.loanAmount,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loanAmount) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  min: "0",
                  placeholder: "5000",
                  "show-label": false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("label", {
              for: "finance-term",
              class: "form-label"
            }, [
              _createTextVNode(" Finance Term "),
              _createElementVNode("span", null, "*")
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              id: "finance-term",
              "aria-label": "Finance Term",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTerm) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.termOptions, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: `finance-term-${option.value}`,
                  value: option.value
                }, _toDisplayString(option.text), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [
                _vModelSelect,
                _ctx.selectedTerm,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_base_group_input, {
              "required-flag": true,
              inputLabel: "Interest Rate",
              "back-group": "%"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_input, {
                  label: "Interest Rate",
                  modelValue: _ctx.interestRate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.interestRate) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  min: "0",
                  step: "0.1",
                  placeholder: "5.25",
                  "show-label": false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("p", null, "Estimated Monthly Payment", -1)),
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "$", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.estMonthlyPayment.toLocaleString()), 1)
            ])
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1))
        ]),
        _renderSlot(_ctx.$slots, "cta")
      ])
    ], 2),
    _createElementVNode("div", _hoisted_9, [
      _renderSlot(_ctx.$slots, "disclaimer")
    ])
  ], 64))
}